













import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-barcode',

})
export default class IBarcode extends Vue {

  @Prop({type: [String], default: '#0A0A0A'}) protected color!: string

}

